import * as React from 'react';
import {
    DataGrid,
    DataGridProps,
    GridRowModel,
    GridColumns,
    GridRowsProp,
    GridEditSingleSelectCell,
    GridEditSingleSelectCellProps,
    GridCellEditStopReasons,
    useGridApiContext,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridRowParams,
    useGridApiRef
} from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import axios from 'axios';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import { Tooltip } from '@mui/material';
import CustomSnackbar from '../../../../../Components/Snackbar/Snackbar';
import { genURL } from '../../../../../_getjson';
const styleMenu = { color: "black", cursor: "pointer" }
//select box 
const CustomTypeEditComponent = (props) => {
    const apiRef = useGridApiContext();
    const handleValueChange = async () => {
        console.log("handleValueChange", props);
        console.log("handleValueChange", props.row);
        console.log("handleValueChange", apiRef);

        // await apiRef.current.setEditCellValue({
        //     id: props.id,
        //     field: 'refReportoptiontype',
        //     value: '',
        // });
    };

    return <GridEditSingleSelectCell onValueChange={handleValueChange} {...props} />;
};

CustomTypeEditComponent.propTypes = {
    /**
     * The grid row id.
     */
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

let idCounter = 0;
const createRow = (nameth, nameen, refReportoptiontype) => {
    idCounter += 1;
    return {
        id: idCounter,
        nameth: nameth,
        nameen: nameen,
        refReportoptiontype: refReportoptiontype
    }

    //{ id: idCounter, nameth: "sss", nameen: "yy", refReportoptiontype: "xxxx" };
};




export default function Optionreport(props) {

    const { defaultDataintable } = props
    //----------------------------snackbar alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")
    //-------------------end  snackbar ------------------------------------------
    const [optiontype, setOptiontype] = React.useState([])
    const editingRow = React.useRef(null);
    const [rows, setRows] = React.useState([]);
    const [delrows, setDelRows] = React.useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);

    const columns = [
        {
            field: 'nameth', headerName: 'ชื่อ(TH)', flex: 1, editable: true
        },
        {
            field: 'nameen', headerName: 'ชื่อ(EN)', flex: 1, editable: true,
            renderCell: (params) => (
                <Tooltip title={`${params.value} ต้องเป็นรูปแบบเดี่ยวกับพารามิเตอร์ของรายงาน`} >
                    <span className="csutable-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'refReportoptiontype',
            headerName: 'ประเภท',
            type: 'singleSelect',
            valueOptions: optiontype,
            flex: 1,
            maxwidth: 150,
            editable: true,
            sortable: false,
            renderEditCell: (params) => (
                <CustomTypeEditComponent  {...params} />
            ),
        },

    ];

    React.useEffect(() => {
        getOptiontype()
        return () => {
        }
    }, [])
    React.useEffect(() => {
        console.log("defaultDataintable", defaultDataintable);
        if (typeof defaultDataintable !== "undefined") {
            // idCounter = defaultDataintable.length + 1
            // setRows(defaultDataintable)
            idCounter = 0
            for (let index = 0; index < defaultDataintable.length; index++) {
                console.log("defaultDataintable index", defaultDataintable[index])
                setRows((prevRows) => [...prevRows, createRow(defaultDataintable[index].nameth, defaultDataintable[index].nameen, defaultDataintable[index].refReportoptiontype)]);
            }
        }
        return () => {
        }
    }, [defaultDataintable])

    const getOptiontype = async () => {
        let urloptiontype = `/reportmanage/optiontype?`
        let elementoptiontype = []

        await axios.get(genURL(urloptiontype)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata getOptiontype", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementoptiontype.push(res.data[index].id + "-" + res.data[index].nameTH)
                }
            }
        }).catch(error => {
            console.log("resdata getOptiontype", error);
        });

        //  await console.log("resdata getOptiontype elementoptiontype", elementoptiontype);
        await setOptiontype(elementoptiontype)
    }
    //--------------------------------- 
    const processRowUpdate = async (newRow) => {

        console.log("checkhandle processRowUpdate", newRow)
        let newRowData = []
        for (let index = 0; index < rows.length; index++) {
            if (newRow.id === rows[index].id && newRow.nameen !== "") {
                newRowData.push(newRow)
            } else {
                newRowData.push(rows[index])
            }
            //   console.log("rows ", rows[index].id)
        }
        // await console.log("rows newRowData", newRowData)
        await setRows(newRowData)

        //   setTimeout(() => {
        await props.Dataintable(newRowData)

        //   }, 200);

        if (newRow.nameth !== "" && newRow.nameen !== "" && newRow.refReportoptiontype !== "") {
            handleAddRow()
        }
        return newRow
    };


    //------------------------------------------ icon


    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <Tooltip describeChild title="เพิ่มแถว" onClick={handleAddRow} style={{ cursor: "pointer" }}>
                    <PlaylistAddRoundedIcon />
                </Tooltip>
                <Tooltip describeChild title="ลบแถว" onClick={e => delData()} style={{ cursor: "pointer", display: selectionModel.length < 1 ? "none" : "block" }} >
                    <DeleteOutlineRoundedIcon />
                </Tooltip>
                {/* <GridToolbarColumnsButton /> */}
                {/* <GridToolbarFilterButton /> */}

                | <GridToolbarDensitySelector sx={styleMenu} />
                {/* <GridToolbarExport /> */}
            </GridToolbarContainer>
        );
    }

    const delData = async () => {
        const selectedIDs = new Set(selectionModel);
        // you can call an API to delete the selected IDs
        // and get the latest results after the deletion
        // then call setRows() to update the data locally here
        await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));

        let row = []
        let delrow = []
        await rows.filter((x) => {
            if (selectedIDs.has(x.id)) {
                delrow.push(x)
                //  console.log("delData sssssssssssssssss", x);
            } else {
                if (x.nameen !== "") {
                    row.push(x)
                }
            }
        })
        await props.Dataintable(row)
        await props.Dataintableremove(delrow)
    }

    // เพิ่มแถวในตาราง
    const handleAddRow = () => {
        setRows((prevRows) => [...prevRows, createRow("", "", "")]);
    };
    //--------------------------------------end icon -----------------------------------------
    return (
        <div style={{ height: 350, width: '100%' }} >
            <DataGrid
                sx={{
                    fontFamily: "Customfont !important",
                    "& .MuiDataGrid-virtualScrollerRenderZone": {
                        "& .MuiDataGrid-row": {
                            "&:nth-child(2n)": { backgroundColor: "rgba(235, 235, 235, .7)", fontFamily: "Customfont !important" }
                        }
                    }
                }}
                rows={rows}
                columns={columns}
                editMode="row"
                processRowUpdate={processRowUpdate}
                checkboxSelection disableSelectionOnClick
                onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}

                experimentalFeatures={{ newEditingApi: true }}

                components={{
                    Toolbar: CustomToolbar,
                }}

            />
            <CustomSnackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
        </div>
    );
}

Optionreport.prototype = {
    defaultDataintable: PropTypes.any
}

